// extracted by mini-css-extract-plugin
module.exports = {"editor":"EditorStyles_editor__1OACf","readOnlyEditor":"EditorStyles_readOnlyEditor__1-6uT"};